<template>
  <div id="app">
    <!-- 로딩 -->
    <div v-if="loading" class="center-screen">
      <div class="spinner" />
    </div>

    <!-- 미로그인: SSO 로그인 화면 -->
    <div v-else-if="!user" class="center-screen login">
      <div class="login-card">
        <div class="login-logo">📅</div>
        <h1>gosky 캘린더</h1>
        <p class="muted">일정을 확인하려면 SSO 로그인이 필요합니다.</p>
        <a class="login-btn" :href="loginUrl">sso.gosky.kr 로 로그인</a>
      </div>
    </div>

    <!-- 로그인됨: 상단바 + 라우터뷰 -->
    <div v-else class="shell">
      <header class="topbar">
        <router-link to="/" class="brand">📅 gosky 캘린더</router-link>
        <nav class="topnav">
          <router-link to="/">캘린더</router-link>
          <router-link to="/settings">설정</router-link>
          <span class="user">{{ user.name || user.email || user.user_id }}</span>
          <button class="ghost" @click="logout">로그아웃</button>
        </nav>
      </header>
      <main class="content">
        <router-view :user="user" />
      </main>
    </div>
  </div>
</template>

<script>
import api from './api';

export default {
  name: 'App',
  data() {
    return { loading: true, user: null, loginUrl: api.loginUrl('/') };
  },
  async created() {
    try {
      this.user = await api.me();
    } catch (e) {
      this.user = null; // 401 → 로그인 화면
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async logout() {
      await api.logout().catch(() => {});
      this.user = null;
    },
  },
};
</script>

<style scoped>
.center-screen {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
}
.spinner {
  width: 40px; height: 40px; border-radius: 50%;
  border: 4px solid var(--border); border-top-color: var(--accent);
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.login-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 20px;
  box-shadow: var(--shadow);
  padding: 40px 32px;
  text-align: center;
  max-width: 360px;
  width: 100%;
}
.login-logo { font-size: 52px; }
.login-card h1 { margin: 12px 0 6px; font-size: 22px; }
.muted { color: var(--muted); font-size: 14px; }
.login-btn {
  display: inline-block;
  margin-top: 20px;
  background: var(--accent);
  color: #fff;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 12px;
  font-weight: 600;
}

.topbar {
  position: sticky; top: 0; z-index: 10;
  display: flex; align-items: center; justify-content: space-between;
  gap: 12px;
  padding: 12px 20px;
  background: color-mix(in srgb, var(--surface) 82%, transparent);
  backdrop-filter: saturate(1.4) blur(10px);
  border-bottom: 1px solid var(--border);
}
.brand { font-weight: 800; text-decoration: none; color: var(--text); font-size: 16px; letter-spacing: -0.02em; }
.topnav { display: flex; align-items: center; gap: 6px; }
.topnav a { text-decoration: none; color: var(--muted); font-size: 14px; font-weight: 500; padding: 6px 10px; border-radius: 8px; transition: background 0.15s, color 0.15s; }
.topnav a:hover { background: var(--accent-weak); color: var(--text); }
.topnav a.router-link-exact-active { color: var(--accent); font-weight: 700; background: var(--accent-weak); }
.topnav .user { margin-left: 6px; }
.topnav .ghost { color: var(--muted); }
.user { font-size: 13px; color: var(--muted); max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.content { max-width: 1100px; margin: 0 auto; padding: 16px; }

@media (max-width: 640px) {
  .user { display: none; }
  .brand { font-size: 14px; }
  .topnav { gap: 10px; }
}
</style>
